import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SearchComponent from "../../components/search/Search";
import ContactDetailView from "../../components/contacts/ContactDetailView";
import TicketDetailView from "../../components/tickets/TicketDetailView";

const useStyles = makeStyles(theme => ({
  overflowHidden: {
    overflow: "hidden"
  }
}));

const Search = () => {
  const [contact, setContact] = useState(null);
  const [ticket, setTicket] = useState(null);
  const classes = useStyles();

  const selectContact = contact => {
    setTicket(null);
    setContact(contact);
  };

  const selectTicket = ticket => {
    setContact(null);
    setTicket(ticket);
  };

  return (
    <Grid container spacing={0} className={classes.overflowHidden}>
      <Grid item xs={12} sm={4}>
        <SearchComponent selectContact={selectContact} selectTicket={selectTicket} />
      </Grid>

      <Grid item xs={12} sm={8}>
        {contact && <ContactDetailView contact={contact} />}
        {ticket && <TicketDetailView ticket={ticket} />}
      </Grid>
    </Grid>
  );
};

export default Search;
